export const CREATEORDER = "CREATEORDER";
export const FETCHORDERS = "FETCHORDERS";
export const FETCHORDER = "FETCHORDER";

export const PLACESTRIPEORDER = "PLACESTRIPEORDER";
